// Centralised feature flag helpers.
// Read from REACT_APP_* env vars baked at build time.

const truthy = (v) => v === true || v === 'true' || v === '1';

export const REFERRALS_ENABLED = truthy(process.env.REACT_APP_REFERRALS_ENABLED);

export default {
  REFERRALS_ENABLED,
};
